/* eslint-disable no-magic-numbers */

import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import wordOvershootScaleInGif from '../../../assets/images/transitions/wordOvershootScaleIn.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_WORD_OVERSHOOT_SCALE_OUT = 'wordOvershootScaleOut';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const wordOvershootScaleOutPresetDetails = {
  // The name of the preset.
  name: PRESET_WORD_OVERSHOOT_SCALE_OUT,

  // A human friendly name for the preset.
  humanName: 'Word Overshoot Scale Out',

  // A preview of the transition.
  gif: wordOvershootScaleInGif,

  // The element names that this preset can be used for or true for all elements.
  elements: ['text'],

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'out',

  // Each property that will change during the transition.
  details: {
    'word.scale': {
      time: {
        end: 'end.0',
        start: 'end.-1480'
      },
      easing: EASINGS.easeInOutBack,
      values: [
        1,
        0
      ],
      immediateRender: false,
      stagger: '200'
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_WORD_OVERSHOOT_SCALE_OUT,
    options: {},
  },
};

wordOvershootScaleOutPresetDetails.template.options = lodash.cloneDeep(wordOvershootScaleOutPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_WORD_OVERSHOOT_SCALE_OUT;

// This defines the value of the presets object.
export default wordOvershootScaleOutPresetDetails;

